import { lockScreen } from 'Utils';
import $ from 'jquery';

function submitForm(e) {
	e.preventDefault();
	const lock = lockScreen();
	const fd = new FormData(e.target);
	const d = $.ajax({
		url: "/ajax.php",
		method: "POST",
		data: fd,
		processData: false,
		contentType: false,
	});
	d.always(() => lock.close());
	const onSuccess = function() {
		$(e.target)
			.html("<p><b>Het bericht is verstuurd</b>.<br/>" +
				"We nemen zo spoedig mogelijk contact op.</p>");
	}
	const onError = function(jqXHR, textStatus, errorThrown) {
		if (jqXHR.responseJSON && jqXHR.responseJSON.error) {
			alert(jqXHR.responseJSON.error);
		} else {
			alert(textStatus + ": " + errorThrown);
		}
	}
	d.then(onSuccess, onError);
}

export function initContactPage() {
	$("form#contact").on("submit", submitForm);
}

export function initAanmeldenformulierPage() {
	$("form#aanmelden").on("submit", submitForm);
}

export function initOverstappenForm() {
	$("form#overstappen").on("submit", submitForm);
}
